/**
 * Created by vikash on 17/05/16.
 */
(function () {
  'use strict';
  angular.module('dtmService.module')
    .run(['$rootScope', 'dtmService', 'dataLayerService',
      function ($rootScope, dtmService, dataLayerService) {
        $rootScope.$on('$stateChangeSuccess', function (evt, toState, toParams, fromState, fromParams) {
          if (toState.dtm) {
            if(toState.dtm.trackDataLayer){
              var  selfServe = {};
              var  event = {};
              var addBasicSection = toState.dtm.addBasicSection ? toState.dtm.addBasicSection : '';
              var referrer = (fromState && fromState.url)? fromState.url : '';
              var currentUrl = (toState && toState.url)? toState.url : '';

              if (toState.dtm.action === 'start') {
                event.selfServeStart = true;
                selfServe = toState.dtm.trackSelfServeInfo;
              }

              var payload = {
                page: toState.dtm.trackPageInfo ? toState.dtm.trackPageInfo: '',
                selfServe: selfServe,
                events: event
              };

              if (_.isEmpty(payload.events)) {
                delete payload.events;
              }
              if (_.isEmpty(payload.selfServe)) {
                delete payload.selfServe;
              }
              if (_.isEmpty(payload.page)) {
                delete payload.page;
              }

              if (!_.isEmpty(payload)) {
                dataLayerService.trackDataLayer(payload, false, addBasicSection, referrer, currentUrl);
              }
              return;
            }
            dtmService.track(toState.dtm.transaction, toState.dtm.type, toState.dtm.action, toState.dtm.project);
          }
        });
      }]);
})();
